import { render, staticRenderFns } from "./PlatformAdvertStair.vue?vue&type=template&id=883fc580&scoped=true&"
import script from "./PlatformAdvertStair.vue?vue&type=script&lang=js&"
export * from "./PlatformAdvertStair.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdvertStair.vue?vue&type=style&index=0&id=883fc580&prod&lang=scss&scoped=true&"
import style1 from "./PlatformAdvertStair.vue?vue&type=style&index=1&id=883fc580&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "883fc580",
  null
  
)

export default component.exports